var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.967 8.75 4.912M24.5 9.334v9.333a2.33 2.33 0 0 1-1.167 2.018l-8.166 4.667a2.33 2.33 0 0 1-2.334 0l-8.166-4.667A2.33 2.33 0 0 1 3.5 18.667V9.334a2.33 2.33 0 0 1 1.167-2.019l8.166-4.666a2.33 2.33 0 0 1 2.334 0l8.166 4.666A2.33 2.33 0 0 1 24.5 9.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.815 8.12 14 14.012 24.185 8.12M14 25.76V14"
  })));
};
export default SvgPackage;